/* eslint-disable */
import { select, call, put, delay } from 'redux-saga/effects'
import { path } from 'ramda'
import AppleMusicActions from '../Redux/AppleMusicRedux'

export const search = function* search(api, action) {
  try {
    console.tron.display({ name: 'AppleMusicSagas', preview: "search", value: { action } })
    const { search } = action
    console.tron.log(`calling yield select`)
    const allState = yield select() // grab state
    const state = allState.appleMusic
    const { token, expires } = state
    let appleMusicToken = null
    console.tron.log(`now ` + Date.now() + `, expires ` + expires)
    if (expires == null || Date.now() > expires) {
      console.tron.log(`calling appleMusicToken`)
      const kargoeResponse = yield call(api.appleMusicToken)
      console.tron.log(`after appleMusicToken`)
      const responsePlus = Object.assign(kargoeResponse, {TimeStamp: timeStamp});
      if (kargoeResponse.ok) {
        const apiResponse = kargoeResponse.data
        const changes = {
          token:   apiResponse.data,
          expires: (apiResponse.meta.expires - 60) * 1000, // php to js time, give a minute leeway
          // do not update timestamp, as that is for watching screens, ie: too early
        }
        console.tron.display({
          name: 'appleMusicSagas',
          preview: "response, response data",
          value: {
            kargoeResponse: kargoeResponse,
            apiResponse: apiResponse,
            data: apiResponse.data,
            expires: apiResponse.meta.expires,
            changes
          }
        })
        appleMusicToken = apiResponse.data
        console.tron.log(`calling searchUpdate 1`)
        yield put(AppleMusicActions.searchUpdate(changes))
      }
    }
    else
      appleMusicToken = token

    api.appleMusicSetHeaders({'Authorization': 'Bearer ' + appleMusicToken})
    const askForTopSongs = search == ''
		console.tron.log(`calling appleMusicTopSongs askForTop: ` + JSON.stringify(askForTopSongs))
		let appleResponse = null
		let tries = 0
		let success = false
		do {
			console.log(`calling appleMusic, try: ${tries} loop start`)
			if (tries > 0)
				yield delay(500)
			console.log(`calling appleMusic, try: ${tries} search ${search}`)
			appleResponse = askForTopSongs ? yield call(api.appleMusicTopSongs) : yield call(api.appleMusicSearch, search)
			console.log(`calling appleMusic after music call`)
			if (appleResponse.ok)
				success = true
			else
				tries++
			console.log(`calling appleMusic, try: ${tries} loop end`)
		} while (!success && tries < 3)
		console.log(`calling appleMusic, after loop`)

    if (appleResponse.ok && appleResponse.data.results.songs) {
      console.tron.log(`appleResponse.ok`)
      const apiResponse = appleResponse.data
      console.tron.display({
        name: 'appleMusicSagas',
        preview: "appleResponse, response data",
        value: {
          appleResponse,
          apiResponse,
          results: apiResponse.results,
          // expires: apiResponse.meta.expires
        }
      })
      const responseSongs = apiResponse.results.songs.length ? apiResponse.results.songs[0].data : apiResponse.results.songs.data
      let songList = []
      responseSongs.forEach((songDetails, i) => {
        const attribs = songDetails.attributes
        if (attribs.previews && attribs.previews.length) {
          // https://is3-ssl.mzstatic.com/image/thumb/Music4/v4/8a/74/7f/8a747f78-7363-77fa-acc1-ce18e2489730/dj.lvfpnksu.jpg/{w}x{h}bb.jpeg
          const imageUrl = attribs.artwork.url.replace('{w}', 216).replace('{h}', 216)
          songList.push({
            id: songDetails.id,
            album: attribs.albumName,
            artist: attribs.artistName,
            song: attribs.name,
            contentRating: attribs.contentRating ? attribs.contentRating : null, // explicit
            detailsUrl: songDetails.href,
            imageUrl,
            musicPreviewUrl: attribs.previews[0].url,
          })
        }
      })
      const now = Date.now()
      // askForTopSongs
      const data = null
      const changes = {
        phase: 'success',
        updated: now,
        data: songList,
        haveCalledBefore: true,
      }
      console.tron.log(`calling searchUpdate 2`)
      yield put(AppleMusicActions.searchUpdate(changes))
    } else {
      console.tron.log(`not appleResponse.ok`)
      const changes = {
        // data: [],
        phase: 'failed',
        error: 'some error occurred'
      }
      console.tron.log(`calling searchUpdate 3`)
      yield put(AppleMusicActions.searchUpdate(changes))
    }
  }
  catch (e) {
    console.tron.display({ name: 'appleMusicSagas', preview: "search error", value: { message: e.message, e: e } })
  }
}
